import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { environment } from 'src/app/environments/environment';
import { PackageStatusResponse } from '../../models/package-status-details.model';
import { CommonUtils } from '../../utils/common/common.utils';
import { ErrorhandleService } from '../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class PackageStatusService {
  private readonly _http = inject(HttpClient);
  private readonly _commonUtils = inject(CommonUtils);
  private readonly _errorHandler = inject(ErrorhandleService);

  readonly baseUrl = environment.apiUrl.concat('/package-status');

  /**
   *get package status
   * @return {*}  {Observable<PackageStatusResponse>}
   * @memberof PackageStatusService
   */
  getPackageStatus(trackingNumber: string): Observable<PackageStatusResponse> {
    this._commonUtils.updateLoadingModal(true);
    return this._http
      .post<PackageStatusResponse>(
        this.baseUrl.concat(`/trackingnumber/${trackingNumber}`),
        {},
      )
      .pipe(
        take(1),
        catchError((error) =>
          this._errorHandler.handleError<PackageStatusResponse>(
            error,
            error.error.code,
            'PackageStatusService: get package status',
            BANNER_TYPE.API_400_ERROR,
          ),
        ),
        finalize(() => {
          this._commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
